import { Checkbox } from "@/components/checkbox";

interface CheckboxWithCountProps {
  label: string;
  count: number | null;
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
}

export const CheckboxWithCount: React.FC<CheckboxWithCountProps> = ({
  label,
  count,
  checked,
  onCheckedChange,
}) => {
  return (
    <div className="flex items-center justify-between">
      <Checkbox
        label={label}
        checked={checked}
        onCheckedChange={onCheckedChange}
      />
      <span className="text-sm text-gray-500">
        {count !== null ? count.toLocaleString() : "0"} items
      </span>
    </div>
  );
};
